import React from 'react';

import Typography from '../../library/typography/typography';

import './installation-costs-message.scss';

function InstallationCostsMessage() {
  return (
    <Typography
      className="installation-costs-message"
      size="small"
      styleName="installation-costs"
    >
      + Installation costs added in cart
    </Typography>
  );
}

export default InstallationCostsMessage;
